export const CONFIGURATIONS_TEXTS = {
  title: 'Claim Bar Configuration',
  description:
    "Define which fields appear in the claim bar for each sub-organization and line of business. Combinations you haven't customized use the Default Form.",
  descriptionWithoutSubOrganizations:
    "Define which fields appear in the claim bar for each line of business. Lines of business you haven't customized use the Default Form.",
  railTitle: 'Configurations',
  defaultLabel: 'Default Form',
  searchPlaceholder: 'Search sub-organization',
  noSearchMatch: 'No sub-organization matches',
  customizedCount: (customized: number, total: number) => `${customized} of ${total} customized`,
  usesDefault:
    "This scope uses the Default Form. Saving a change here gives it a configuration of its own; fields you don't change keep following the Default Form.",
  customFollowsDefault: "Fields you haven't changed here follow the Default Form.",
  usesDefaultFnolNote: "Only fields active in this scope's FNOL Configuration are listed.",
  resetToDefault: 'Reset to Default',
  resetConfirmTitle: 'Reset this configuration to the Default Form?',
  resetConfirmText: 'Every change made here is cleared, so claims in this scope use the Default Form.',
  readOnlyNotice: 'You can view this configuration but not edit it.',
  custom: 'Custom',
  lastUpdated: (date: string, username: string | null) =>
    username ? `Last updated ${date} by ${username}` : `Last updated ${date}`,
  fieldsHeading: 'Claim bar fields',
  fieldsCount: (shown: number, hidden: number) => `${shown} shown · ${hidden} hidden`,
  addField: 'Add Field',
  noCatalogFields: 'Nothing to add here',
  save: 'Save',
  savedAfterLostResponse: 'Your changes were saved.',
  saveConnectionLost: "Couldn't save your changes. Check your connection and try Save again.",
  cancel: 'Cancel',
  discardTitle: 'Discard your unsaved changes?',
  discardText: 'Your changes to this configuration have not been saved and will be lost.',
  discardConfirm: 'Discard',
  nameRequiredOnSave: 'Field name is required',
  leaveWithoutSaving: 'Are you sure you want to leave without saving?',
  defaultPropagation: 'A field added here reaches every configuration that has not set it.',
} as const;
